// extracted by mini-css-extract-plugin
module.exports = {"pageEmpty__content":"c3_r4","pageEmpty__image":"c3_r5","pageEmpty__text":"c3_r6"};